/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { RebrandShell } from 'components/rebrand/RebrandShell';
import { ExtratoDetalheModal } from 'components/extrato-detalhe-modal';
import { GroupDetailModalExtrato } from 'components/group-detail-modal-extrato';
import Recognition from 'components/recognition';
import RecognitionReceived from 'components/recognitionReceived';
import { IconPlus } from 'components/rebrand/icons';

import Dimensions from './Component/Dimensions';
import './styles.scss';

type RecognitionTab = 'RECEIVED' | 'SENDED';

export default function Historico() {
  const location = useLocation();
  const navigate = useNavigate();

  const [recognitionTab, setRecognitionTab] = useState<RecognitionTab>('RECEIVED');
  const [filter] = useState({});

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const sub = searchParams.get('sub') as RecognitionTab | null;

    if (sub === 'RECEIVED' || sub === 'SENDED') {
      setRecognitionTab(sub);
      searchParams.delete('sub');
      searchParams.delete('active');
      window.history.replaceState({}, '', window.location.pathname + (searchParams.toString() ? '?' + searchParams.toString() : ''));
    }
  }, [location]);

  return (
    <RebrandShell
      title="Meus Reconhecimentos"
      subtitle="Acompanhe os reconhecimentos que você recebeu e enviou em cada dimensão da Cultura."
    >
      <div className="rb-extrato-top">
        <div className="rb-extrato-tabs">
          <button
            type="button"
            className={`rb-toggle ${recognitionTab === 'RECEIVED' ? 'rb-toggle--on' : 'rb-toggle--off'}`}
            onClick={() => setRecognitionTab('RECEIVED')}
          >
            Recebidos
          </button>
          <button
            type="button"
            className={`rb-toggle ${recognitionTab === 'SENDED' ? 'rb-toggle--on' : 'rb-toggle--off'}`}
            onClick={() => setRecognitionTab('SENDED')}
          >
            Enviados
          </button>
        </div>

        <button type="button" className="rb-btn-primary rb-extrato-send" onClick={() => navigate('/reconhecer')}>
          <IconPlus size={16} /> Enviar reconhecimento
        </button>
      </div>

      <h3 className="rb-extrato-heading">Dimensões do Comportamento</h3>
      <Dimensions tab={recognitionTab} />

      {recognitionTab === 'RECEIVED' ? (
        <RecognitionReceived filter={filter} />
      ) : (
        <Recognition filter={filter} />
      )}

      <GroupDetailModalExtrato />
      <ExtratoDetalheModal />
    </RebrandShell>
  );
}
